const base = {
  default: {
    flexWrap: 'wrap',
    height: '100%'
  }
};

const container = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base
  }
};

export type ContainerVariantsType = 'default';
export const containerVariants = Object.keys(base) as ContainerVariantsType[];

export default container;
